(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.championships.championship.editMatches
   * @description
   *
   */
  angular
    .module('neo.home.championships.championship.editMatches', [
      'ui.router'
    ]);
}());
